import React from 'react'
import {connect} from 'react-redux'
import Firebase from 'firebase'

import config from '../shared/config/dev'
import {
  USER_REPORTS_ENDPOINT,
  REPORT_NOTIFICATIONS_ENDPOINT
} from '../shared/config/constants'

import closeModal from '../shared/data/actions/close_modal'

import ModalView from '../shared/modal_view'

class ReportModal extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      isActive: true
    }
    this.onClose = this.onClose.bind(this)
  }

  componentWillUnmount () {
    if (this.reportUserRef) this.reportUserRef.off()
  }

  onClose (e) {
    if (e) e.stopPropagation()

    this.setState({
      isActive: false,
      isReportModalSubmitted: false
    })

    this.props.closeModal(this.props.modalKey)
  }

  submitReport (e) {
    if (e) e.stopPropagation()

    this.reportUser(this.props.reportee, {comment: this.refs.reportComment.value})
    this.setState({isReportModalSubmitted: true})
  }

  saveReportNotification (reporter, reportee, comment, time) {
    let endpoint = `${config.firebaseUrl}${REPORT_NOTIFICATIONS_ENDPOINT}`
    let ref = new Firebase(endpoint)

    ref.push({
      to: reportee.get('uid'),
      from: reporter.get('uid'),
      read: false,
      time,
      _isNotifServiceRead: false,
      payload: {
        comment,
        reporter: {
          name: reporter.get('name'),
          uid: reporter.get('uid')
        },
        reportee: {
          name: reportee.get('name'),
          uid: reportee.get('uid')
        }
      }
    })
  }

  reportUser (reportee, {comment}) {
    if (this.props.currentUser && typeof(reportee) === 'object') {
      let endpoint = `${config.firebaseUrl}${USER_REPORTS_ENDPOINT(reportee.get('uid'))}`
      this.reportUserRef = new Firebase(endpoint)

      this.reportUserRef.push({
        reporter: this.props.currentUser.get('uid'),
        comment: comment,
        time: Firebase.ServerValue.TIMESTAMP
      })
      .then((ref) => {
        ref.child('time').once('value')
        .then((snapshot) => {
          if (snapshot.val()) {
            this.saveReportNotification(this.props.currentUser, reportee, comment, snapshot.val())
          }
        })
      })
    }
  }

  renderModalContent () {
    if (this.state.isReportModalSubmitted) {
      return (
        <div>
          <div className='modal-header'>
            <h3 style={{fontSize: 18, margin: '10px 0'}}>Report User</h3>
          </div>
          <div className='modal-body'>
            <div className='alert success alert-success'>
              You have reported this user.
            </div>
          </div>
          <div className='modal-footer'>
            <div className='actions right'>
              <div className='cancel button default' onClick={this.onClose.bind(this)}>Close</div>
            </div>
          </div>
        </div>
      )
    }
    else {
      return (
        <div>
          <div className='modal-header'>
            <h3 style={{fontSize: 18, margin: '10px 0'}}>Report User</h3>
          </div>
          <div className='modal-body'>
            <div className='alert danger alert-danger'>
              You are about to report this user as an abusive member of the community. Please provide us with a comment as to why you are reporting this user.
            </div>
            <div className='form' style={{width: '100%'}}>
              <div className='form-element' style={{width: '100%'}}>
                <textarea ref='reportComment' placeholder='Your comment...' style={{height: '100px', width: '100%', borderColor: '#EEEEEE', borderRadius: '4px', padding: '5px 10px'}}/>
              </div>
            </div>
          </div>
          <div className='modal-footer'>
            <div className='actions right'>
              <div className='button danger' onClick={this.submitReport.bind(this)}>Submit report</div>
              <div className='cancel button default' onClick={this.onClose.bind(this)}>Cancel</div>
            </div>
          </div>
        </div>
      )
    }
  }

  render () {
    return (
      <ModalView isActive={this.state.isActive} onClose={this.onClose}>
        {this.renderModalContent()}
      </ModalView>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.get('currentUser')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: (modalKey) => dispatch(closeModal(modalKey))
  }
}

const ReportModalContainer = connect(
  mapStateToProps, mapDispatchToProps
)(ReportModal)

export default ReportModalContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/report_modal.js
 **/